/*
 * BuildDocs пользовательский интерфейс version 0.1.0
 *
 * Copyright © 2022 ООО АДАПТ info@acfs.spb.ru
 * You may use, distribute and modify this code under the
 * terms of the ООО АДАПТ license
 */

import React, { FC } from 'react'

import { useRouter } from '@builddocs/data-management'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import TreeView from '@mui/lab/TreeView'
import { Skeleton } from '@mui/material'

import TreeContracts from './TreeContracts'

import type { UUID } from '@builddocs/data-management'

type Props = {
  currentProjectId: UUID | undefined
  currentContractId: UUID | undefined
}

export const ContainerTree: FC<Props> = ({
  currentProjectId,
  currentContractId,
}) => {
  const { navigate } = useRouter()

  const handleGoToContract = (_event: unknown, nodeId: string) => {
    const [projectId, contractId] = nodeId.split(':')

    if (contractId) {
      navigate(`/projects/${projectId}/contracts/${contractId}`)
    } else {
      navigate(`/projects/${projectId}`)
    }
  }
  const currentProjectNodeId = currentProjectId ?? ''
  const currentContractNodeId = currentContractId
    ? `${currentProjectId}:${currentContractId}`
    : currentProjectId ?? ''

  const [expanded, setExpanded] = React.useState<string[]>([
    currentProjectNodeId,
  ])
  const handleToggle = (_event: React.SyntheticEvent, nodeIds: string[]) => {
    setExpanded(nodeIds)
  }

  if (!currentProjectId)
    return <Skeleton height={32} variant="rectangular" width="100%" />

  return (
    <TreeView
      aria-label="projects-tree-view"
      defaultCollapseIcon={<ExpandMoreIcon />}
      defaultExpandIcon={<ChevronRightIcon />}
      expanded={expanded}
      selected={currentContractNodeId}
      sx={{ position: 'relative' }}
      onNodeSelect={handleGoToContract}
      onNodeToggle={handleToggle}
    >
      <TreeContracts projectId={currentProjectId} />
    </TreeView>
  )
}
